
import { CheckoutStepId } from '../../components/pages/Checkout/config';
import { CheckoutStepAction, placeOrder, PlaceOrderDoneAction, setActiveStep } from '../../redux/actions/checkout';
import { CheckoutEvent, EventCategory, EventDefinition, EventsMap } from '../types';
import { licenseLineItemToLicenseStr } from './cart';

const checkoutStepUpdate: EventDefinition<CheckoutStepAction> = (_, prevState, nextState) => {
  const prevActiveStep = prevState.checkout.activeStep;

  // If an order was just placed, don't track the setActiveStep action
  // as it's the form being reset.
  if (prevActiveStep === CheckoutStepId.orderPlaced) {
    return;
  }

  return {
    category: EventCategory.Checkout,
    event: CheckoutEvent.Checkout,
    action: CheckoutEvent.Checkout,
    label: `checkout-step:${nextState.checkout.activeStep}`,
    ecommerce: {
      checkout: {
        actionField: { step: nextState.checkout.completedSteps.length + 1 },
        // products: [{
        // }],
      },
    },
  };
};

const placeOrderComplete: EventDefinition<PlaceOrderDoneAction> = (action) => {
  const newOrder = action.payload.result.order!;
  return {
    category: EventCategory.Checkout,
    event: CheckoutEvent.PlaceOrder,
    action: CheckoutEvent.PlaceOrder,
    label: `Invoice #${newOrder.invoice_number}`,
    ecommerce: {
      currencyCode: newOrder.currency_code,
      purchase: {
        actionField: {
          id: newOrder.invoice_number,
          affiliation: '',
          revenue: newOrder.total! * newOrder.currency_rate!,
          tax: newOrder.tax_line_items ? newOrder.tax_line_items.reduce((total, cur) => total + cur.amount!, 0) : 0,
          shipping: '',
          coupon: newOrder.promo_code_line_item ? newOrder.promo_code_line_item.code : '',
        },
        products: newOrder.license_line_items!.map((item) => {
          return {
            name: item.track!.title,
            id: item.track!.internal_id,
            price: (item.amount! - item.discount_amount!) * newOrder.currency_rate!,
            brand: item.track!.artist!.name,
            category: 'License',
            variant: licenseLineItemToLicenseStr(item),
            quantity: 1,
            coupon: '',
          };
        }),
      },
    },
  };
};

export const checkoutEventsMap: EventsMap = {
  [setActiveStep.type]: checkoutStepUpdate,
  [placeOrder.done.type]: placeOrderComplete,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/checkout.ts